import {Component, Input, OnInit} from '@angular/core';

interface ClassroomAPIResponse {
  success: boolean;
  code?: number;
  data?: any; // API request data
  response?: any; // API response object
}

@Component({
  selector: 'app-single-log-entry',
  templateUrl: './single-log-entry.component.html',
  styleUrls: ['./single-log-entry.component.scss']
})
export class SingleLogEntryComponent implements OnInit {
  @Input() data;
  @Input() debug;
  @Input() showErrorsOnly;

  panelOpenState = false;
  error = false;

  renderAlias: string;
  renderClassName: string;
  statusIcon = 'check';
  renderTeacher: string;

  constructor() {}

  ngOnInit() {
    this.error = !!this.data.error;
    this.renderAlias = this.getAlias();
    this.renderClassName = this.getClassName();
    this.statusIcon = this.getStatusIcon();
    this.renderTeacher = this.getTeacher();
  }

  _parseErrorCode(response: ClassroomAPIResponse | any): string {
    let rtn = (response.success) ? 'SUCCESS' : 'FAIL';
    const code = response?.code || response?.errorCode;
    const message = response?.message || response?.errorMessage;
    if (code && code !== 200) {
      switch (code) {
        case 409:
          rtn += ` : 409 Already exists`;
          break;
        case 404:
          rtn += ` : 404 Not found`;
          break;
        case 403:
          rtn += ` : 403 Permission denied`;
          break;
        default:
          rtn += ` : ${code} API error encountered${message ? ` - ${message}` : ''}`;
          break;
      }
    }
    return rtn;
  }

  getClassName() {
    let rtn = this.data.name || `Class name missing - [ID:${this.data.id}]`;
    if (this.data.section) {
      rtn += ` (${this.data.section})`;
    }
    return rtn;
  }

  getTeacher() {
    if (this.data.teacher && this.data.teacher.name) {
      return `${this.data.teacher.name} (${this.data.teacher.email})`;
    } else {
      return 'Teacher details missing';
    }
  }

  getAlias() {
    if (this.data?.id?.substring(0, 5) === 'd:LS_') {
      return `[${this.data.id.substring(5)}]`;
    } else {
      return `[${this.data.id}]`;
    }
  }

  getStatusIcon() {
    return this.error ? 'error' : 'check';
  }

}
